module.exports = __webpack_public_path__ + "static/media/iceland_001.fa9a5bf3.jpg";